import { render, staticRenderFns } from "./ServiceLoopsList.vue?vue&type=template&id=0e8f72cc"
import script from "./ServiceLoopsList.vue?vue&type=script&lang=ts"
export * from "./ServiceLoopsList.vue?vue&type=script&lang=ts"
import style0 from "./ServiceLoopsList.vue?vue&type=style&index=0&id=0e8f72cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports